import { QueryClient } from '@tanstack/react-query';

// Shared QueryClient with conservative defaults tuned for this app:
//  - staleTime 30s so quick navigations don't refetch on every mount.
//  - retry once (the http client already does one 401-refresh; a single
//    network retry covers transient blips without hammering the API).
//  - no refetch on window focus — dashboards here aren't real-time tickers.
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });

// A ready-to-use singleton for the app entrypoint. Tests can build their own
// via createQueryClient() to keep cache isolation.
export const queryClient = createQueryClient();
